import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Row, Col, Container, Table, Label } from "reactstrap";
import StoreContext from "./../../../Store/Context";
import {
  getcxcDetailByCxc_id,
  getcxcByPerson,
  getcxc_cobrar,
  getRPagoDetail,
  getMonto,
  getCxc,
} from "../../Constants/Services";
import {
  BODY_CUENTAS_REPORT,
  validateTokenStorage,
  GET_SUM_T_PAGO,
} from "./../../Constants/Util";
import {
  ICxcDetail,
  IFormMatricula2,
  IMontoDate,
  IMonto,
  ICxcType,
  IGradeSelected,
  Icxc_cobrar,
  IRegistration,
  IRDPago,
  IDropDates,
} from "./../../Constants/Interfaces";

interface ICuentasState {
  dataCxcDetail: ICxcDetail[];
  dataMontoDate: IMontoDate[];
  formMatricula: IFormMatricula2;
  dataCxcType: ICxcType[];
  loading: boolean;
  ap_desc: string;
  formMonto: IMonto;
  dropDates: IDropDates[];
  cxc_cobrar: Icxc_cobrar[];
  dataRegistration: IRegistration[];
  dataFormRPagoD: IRDPago;
  dataRPagoD: IRDPago[];
  dataGradeSelected: IGradeSelected;
}

class Payments extends Component<RouteComponentProps<{}>, ICuentasState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      cxc_cobrar: [],
      dataRegistration: [],
      dropDates: [],
      formMonto: {
        mt_id: "",
        mt_grade: "",
        mt_year: "",
        mt_mensualidad_r: "",
        mt_mensualidad_hm: "",
        mt_mensualidad_hd: "",
        mt_matricula_r: "",
        mt_matricula_hm: "",
        mt_matricula_hd: "",
        mt_plataforma: "",
        mt_laboratorio: "",
        mt_efisica: "",
        mt_otro_monto: "",
        mt_otro_desc: "",
        mt_anualidad_r: "",
        mt_anualidad_hm: "",
        mt_anualidad_hd: "",
        mt_a_plataforma: "",
        mt_a_laboratorio: "",
        mt_a_robotica: "",
        mt_robotica: "",
        mt_a_efisica: "",
        t_status: "",
      },
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        rpd_secuencia: "",
        rpd_cxc: "",
        tp_desc: "",
      },
      dataRPagoD: [],
      dataCxcDetail: [],
      dataMontoDate: [],
      dataCxcType: [],
      formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
        cxcr_debep: "",
        per_cedula: "",
        reg_grade:""
      },
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
      loading: false,
      ap_desc: "",
    };

    this.fetchType = this.fetchType.bind(this);
    this.fetchCxcByPerson = this.fetchCxcByPerson.bind(this);
    this.fetchRPagoDetail = this.fetchRPagoDetail.bind(this);
    this.fetchMonto = this.fetchMonto.bind(this);
    this.fetchcxc_cobrar = this.fetchcxc_cobrar.bind(this);
    this.fetchCxc = this.fetchCxc.bind(this);
  }

  async fetchRPagoDetail(props: any) {
    const response = await getRPagoDetail(
      props.per_id + props.per_cedula + props.reg_id
    );
    var result = 0;
    response.map((data, i) => {
      result = Number(result) + Number(data.rpd_monto);
      return null;
    });
    this.setState({
      dataRPagoD: response,
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        tp_desc: "",
        rpd_secuencia: "",
        rpd_cxc: "",
      },
      loading: false,
    });
  }

  async fetchMonto({ gr_id }) {
    const response = await getMonto(gr_id, this.context.year);
    var matricula = "";
    var mensualidad = "";
    if (response.mt !== undefined && response.mtd !== undefined) {
      if (this.state.formMatricula.cxcr_tcuenta === "3") {
        matricula = response.mt[0].mt_matricula_hd;
        mensualidad = response.mt[0].mt_mensualidad_hd;
      } else if (this.state.formMatricula.cxcr_tcuenta === "2") {
        matricula = response.mt[0].mt_matricula_hm;
        mensualidad = response.mt[0].mt_mensualidad_hm;
      } else {
        matricula = response.mt[0].mt_matricula_r;
        mensualidad = response.mt[0].mt_mensualidad_r;
      }

      this.setState({
        formMonto: response.mt[0],
        dataMontoDate: response.mtd,
        dropDates: response.m_dates,
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_matricula: matricula,
          cxcr_mensualidad: mensualidad
        },
        loading: false,
      });
    } else {
      this.setState({
        dataMontoDate: [],
        formMonto: {
          mt_a_robotica: "",
          mt_robotica: "",
          mt_id: "",
          mt_grade: "",
          mt_year: "",
          mt_mensualidad_r: "",
          mt_mensualidad_hm: "",
          mt_mensualidad_hd: "",
          mt_matricula_r: "",
          mt_matricula_hm: "",
          mt_matricula_hd: "",
          mt_plataforma: "",
          mt_laboratorio: "",
          mt_efisica: "",
          mt_otro_monto: "",
          mt_otro_desc: "",
          mt_anualidad_r: "",
          mt_anualidad_hm: "",
          mt_anualidad_hd: "",
          mt_a_plataforma: "",
          mt_a_laboratorio: "",
          mt_a_efisica: "",
          t_status: "",
        },
        loading: false,
      });
    }
  }

  async fetchcxc_cobrar(reg_id: string) {
    const response = await getcxc_cobrar(reg_id, this.context.year);
    this.setState({
      cxc_cobrar: response,
      loading: false,
    });
  }

  async fetchCxc(reg_id: string) {
    const response = await getCxc(reg_id, this.context.year);
    // if (response.length > 0) {
    if (response[0] !== undefined) {
      this.setState({
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_id: response[0].cxcr_id,
          cxcr_registration: response[0].cxcr_registration,
          cxcr_tcuenta: response[0].cxcr_tcuenta,
          cxcr_stado: response[0].cxcr_stado,
          cxcr_saldo: response[0].cxcr_saldo,
          cxcr_status: response[0].cxcr_status,
          cxcr_date: response[0].cxcr_date,
          cxcr_anualidad: response[0].cxcr_anualidad,
          cxcr_saldo_cole: response[0].cxcr_saldo_cole,
          cxcr_anualidad_state: response[0].cxcr_anualidad_state,
          per_cedula: response[0].per_cedula,
        },
        loading: false,
      });
      this.fetchcxc_cobrar(reg_id);
    }

    this.fetchMonto({ gr_id: this.state.formMatricula.reg_grade });
  }

  async fetchType({ cxc_id }) {
    const response = await getcxcDetailByCxc_id(cxc_id);
    this.setState({
      dataCxcDetail: response,
    });
  }

  async fetchCxcByPerson({ per_id }) {
    const response = await getcxcByPerson(per_id);
    var ap_desc;
    if (response.apayment[0] !== undefined) {
      ap_desc = response.apayment[0].ap_desc;
    }

    this.setState({
      dataMontoDate: response,
      loading: false,
      formMatricula: {
        ...this.state.formMatricula,
        cxcr_matricula:
          response.cxcr_cxcregistration[0] !== undefined
            ? response.cxcr_cxcregistration[0].cxcr_matricula
            : "0",
        cxcr_saldo:
          response.cxcr_cxcregistration[0] !== undefined
            ? response.cxcr_cxcregistration[0].cxcr_saldo
            : "0",
        cxcr_anualidad:
          response.cxcr_cxcregistration[0] !== undefined
            ? response.cxcr_cxcregistration[0].cxcr_anualidad
            : "0",
        cxcr_anualidad_state:
          response.cxcr_cxcregistration[0] !== undefined
            ? response.cxcr_cxcregistration[0].cxcr_anualidad_state
            : "0",
        cxcr_saldo_cole:
          response.cxcr_cxcregistration[0] !== undefined
            ? response.cxcr_cxcregistration[0].cxcr_saldo_cole
            : "0",
        cxcr_stado:
          response.cxcr_cxcregistration[0] !== undefined
            ? response.cxcr_cxcregistration[0].cxcr_stado
            : "0", 
            reg_grade: response.cxcr_cxcregistration[0].reg_grade,
      },
      dataCxcType: response.cxc_cxcobrar,
      ap_desc: response.apayment[0] !== undefined ? ap_desc : "",
     
    });

    this.fetchCxc(
      response.cxcr_cxcregistration[0] !== undefined
        ? response.cxcr_cxcregistration[0].cxcr_registration
        : "0"
    );
    var row = {
      per_id: this.context.per_std,
      per_cedula: response.cxcr_cxcregistration[0].per_cedula.replace(
        /\D/g,
        ""
      ),
      reg_id: response.cxcr_cxcregistration[0].cxcr_registration,
    };
    this.fetchRPagoDetail(row);

  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchCxcByPerson({ per_id: this.context.per_std });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container>
          <Row>
            <Col xs={12} className="text-center mb-4">
              <h4 className="font-weight-bold">Pagos y Cuentas</h4>
            </Col>
          </Row>
          <Row>
            {props.cxc_cobrar.length > 0 ? (
              <React.Fragment>
                <Col xs={12} className="mt-3 text-center info">
                  <Label>
                    <b>COLEGIATURA</b>
                  </Label>
                </Col>
                <Col xs={12}>
                  <Table bordered>
                    <thead>
                      <tr>
                        <th className="text-center">
                          <b>Tipo de pago</b>
                        </th>
                        <th className="text-center">
                          <b>Monto</b>
                        </th>
                        <th className="text-center">
                          <b>Cancelado</b>
                        </th>
                        <th className="text-center">
                          <b>Por pagar</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <Row className="text-center">
                            <Col xs={12}>
                              <b>Matricula</b>
                            </Col>
                          </Row>
                        </td>
                        <td>
                          {" "}
                          <Row className="text-center">
                            <Col xs={12}>
                              {props.formMatricula.cxcr_matricula}
                            </Col>
                          </Row>
                        </td>
                        <td>
                          {" "}
                          <Row className="text-center">
                            <Col xs={12}>
                              {props.formMatricula.cxcr_stado === "1"
                                ? GET_SUM_T_PAGO(
                                    props.dataRPagoD,
                                    "2",
                                    false,
                                    null
                                  ).toFixed(2)
                                : "B/."}
                            </Col>
                          </Row>
                        </td>
                        <td>
                          {" "}
                          <Row className="text-center">
                            <Col xs={12}>
                              {props.formMatricula.cxcr_stado === "1"
                                ? (
                                    Number(props.formMatricula.cxcr_matricula) -
                                    Number(
                                      GET_SUM_T_PAGO(
                                        props.dataRPagoD,
                                        "2",
                                        false,
                                        null
                                      ).toFixed(2)
                                    )
                                  ).toFixed(2)
                                : "B/."}
                            </Col>
                          </Row>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <Col xs={12}>
                    <BODY_CUENTAS_REPORT props={props} />
                  </Col>
                </Col>
              </React.Fragment>
            ) : null}
          </Row>
          {/* <PAYMENT_ACCOUNT_STUDENT props={props}  fetchType ={this.fetchType} dataCxc ={props.dataCxcDetail} /> */}
        </Container>
      </React.Fragment>
    );
  }
}

export default Payments;
